import { z } from 'zod'

export const SessionSchema = z.object({
  token: z.string().min(1),
  user_id: z.string().min(1),
  family_id: z.string().min(1),
})
export type Session = z.infer<typeof SessionSchema>
